// frontend/src/features/auth/ResetPassword.js
// This React page implements the Reset Password flow, letting users submit a new password with their reset token from the URL and showing success or error messages based on the API response.
import React, { useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage]         = useState(null);
  const [error, setError]             = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    try {
      const { data } = await axios.post(
        'http://localhost:5000/api/auth/reset-password',
        { token, newPassword },
        { headers: { 'Content-Type': 'application/json' } }
      );
      setMessage(data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Error resetting password');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center mb-6">Reset Password</h2>

        {message && (
          <div className="mb-4 text-sm text-green-700 bg-green-100 p-3 rounded">
            {message}
          </div>
        )}
        {error && (
          <div className="mb-4 text-sm text-red-700 bg-red-100 p-3 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="new-password" className="block text-gray-700 mb-2">
              New Password
            </label>
            <input
              id="new-password"
              type="password"
              required
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded
                         focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-primary text-white rounded
                       hover:bg-primary/90 transition"
          >
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
}
